import axios from '@/plugins/axios';

export function createAddUserRequest(data, config) {
    return axios.post('/add-user-requests', data, config);
}